module.exports = __webpack_public_path__ + "static/img/multiple-brands-01.ed165c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/multiple-brands-01.jpg
// module id = 277
// module chunks = 1